import script from "./NoBgSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./NoBgSelect.vue?vue&type=script&setup=true&lang=js"

import "./NoBgSelect.vue?vue&type=style&index=0&id=f58c8f54&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f58c8f54"]])

export default __exports__